import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const notificationService = {
  getList: (data) => api.post(API_PATHS.NOTIFICATIONS_LIST, data),
  getUnreadCount: () => api.post(API_PATHS.NOTIFICATIONS_UNREAD_COUNT),
  markAsRead: (data) => api.post(API_PATHS.NOTIFICATIONS_MARK_READ, data),
  markAllAsRead: () => api.post(API_PATHS.NOTIFICATIONS_MARK_ALL_READ),
  delete: (data) => api.post(API_PATHS.NOTIFICATIONS_DELETE, data),
  getSmartAlerts: () => api.post(API_PATHS.NOTIFICATIONS_SMART_ALERTS),
};

export default notificationService;
